/**
 * Created by hp on 2017/5/25.
 */
const defaults = {
    pptAreaHeight: Math.ceil(Math.min(480, window.innerWidth || screen.width) * 1080 / 1920),
    showPPTMaterialPanel: false,
    ppts: [],
    operatePPT: {},
    selectedPPTIndex: 0,
    isSelectPPT: false,
    isRefreshPPT: false,
    selectedPPTId: 0,
};

export default (state = defaults, action) => {
    const range = 2
    switch (action.type) {
        case 'OPEN_PPT_MATERIAL_PANEL':
            return {...state, showPPTMaterialPanel: true};
        case 'HIDE_PPT_MATERIAL_PANEL':
            return {...state, showPPTMaterialPanel: false, isSelectPPT: false};
        case 'CLASSROOM_SET_PPT':
            return {...state, ppts: action.ppts};
        case 'CLASSROOM_REFRESH_PPT':
            return {...state, ppts: action.ppts, isRefreshPPT: true};
        case 'CLASSROOM_ADD_PPT':
            if(state.ppts.filter(v=>v.id === action.payload.id).length){
                break
            }
            state.ppts.push(action.payload);
            return {...state, ppts: state.ppts, isRefreshPPT: true};
        case 'CLASSROOM_UPDATE_PPT':
            return {...state, ppts: state.ppts.map( v=> v.id === action.payload.old_id ? Object.assign({}, v, action.payload): v), isRefreshPPT: true}
        case 'CLASSROOM_REFRESH_PPT_DONE':
            return {...state, isRefreshPPT: false};
        case 'CLASSROOM_UNSET_SELECT_PPT':
            return {...state, isSelectPPT: false};
        case 'CLASSROOM_SET_OPERATE_PPT':
            return {...state, operatePPT: action.operatePPT};
        case 'CLASSROOM_SET_SELECTED_PPT_INDEX':
            if(action.selectedPPTIndex >= 0){
                let ppt_index = action.selectedPPTIndex
                let ppts = state.ppts
                for(let i = ppt_index - range; i < ppt_index + range; i++){
                    if(i >=0 && i < ppts.length){
                        ppts[i].loaded = true;
                    }
                }
            }

            return {...state, selectedPPTIndex: action.selectedPPTIndex, isSelectPPT: true};
        case 'CLASSROOM_SET_SELECTED_PPT':
            let ppt_index = null;
            for (let i = 0; i < state.ppts.length; i++) {
                if (state.ppts[i].id === action.payload.id) {
                    ppt_index = i;
                    break
                }
            }

            if (ppt_index === null) {
                return {...state}
            } else {
                let ppts = state.ppts
                for(let i = ppt_index - range; i < ppt_index + range; i++){
                    if(i >=0 && i < ppts.length){
                        ppts[i].loaded = true;
                    }
                }
                return {...state, selectedPPTIndex: ppt_index, isSelectPPT: true, selectedPPTId: action.payload.id}
            }

        default:
            return state;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/ppt.js